import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider/lib/Slider';
import 'rc-slider/assets/index.css';
import './SliderBar.scss';

class SliderBar extends PureComponent {
  static propTypes = {
    value: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    stepValue: PropTypes.number,
    onValueChanged: PropTypes.func
  };

  static defaultProps = {
    maxValue: 50,
    minValue: -50,
    stepValue: 10,
    value: 0
  };

  constructor(props) {
    super(props);

    let value = typeof this.props.value === 'number' ? this.props.value : 0;
    this.stepValue = typeof this.props.stepValue === 'number' ? this.props.stepValue : 10;
    this.maxValue = typeof this.props.maxValue === 'number' ? this.props.maxValue : 50;
    this.minValue = typeof this.props.minValue === 'number' ? this.props.minValue : -50;
    this.maxRange = parseInt(this.maxValue, 10) - parseInt(this.minValue, 10);

    if (value > this.props.maxValue) {
      value = this.props.maxValue;
    }

    if (value < this.props.minValue) {
      value = this.props.minValue;
    }

    this.state = {
      sliderValue: value
    };

    this._determineWeights = this._determineWeights.bind(this);
    this._updateState = this._updateState.bind(this);
    this._afterSelection = this._afterSelection.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        sliderValue: this.props.value
      });
    }
  }

  // returns an array of integers, always of length 2
  _determineWeights(value) {
    // left weight is current value's distance from right (maxValue)
    const leftWeight = parseInt(this.maxValue, 10) - parseInt(value, 10);
    // right weight is the inverse of the left,
    // e.g. difference between the left weight and maxRange
    const rightWeight = parseInt(this.maxRange, 10) - parseInt(leftWeight, 10);
    return [leftWeight, rightWeight];
  }

  _determineOpacity(value) {
    const normalizedPercentOf100 = value / this.maxRange;
    if (normalizedPercentOf100 >= 0.5) return 1;
    // minimum of 30% opacity, scales up towards 100% opacity at 50%
    return normalizedPercentOf100 * 1.25 + 0.3;
  }

  _determinePercentStyle(value, jss = true) {
    if (jss) {
      return {
        opacity: this._determineOpacity(value)
      };
    }
    return `
      opacity: ${this._determineOpacity(value)};
    `;
  }

  _updateState(value) {
    this.setState({
      sliderValue: value
    });
  }

  _afterSelection(value) {
    // chosen weights is an array of the left and right weight values
    const chosenWeights = this._determineWeights(value);
    if (this.props.onValueChanged) {
      this.props.onValueChanged(chosenWeights);
    }
  }

  render() {
    const weights = this._determineWeights(this.state.sliderValue);
    const leftWeight = weights[0];
    const rightWeight = weights[1];
    const leftStyle = this._determinePercentStyle(leftWeight);
    const rightStyle = this._determinePercentStyle(rightWeight);

    return (
      <div className="slider-bar">
        <span className="slider-bar__weight-percent slider-bar__weight-percent--left" style={leftStyle}>
          <span className="slider-bar__weight-percent-number slider-bar__weight-percent-number--left">
            {leftWeight}
          </span>
          %
        </span>
        <div className="slider-bar__input-slider">
          <Slider
            dots
            min={this.minValue}
            max={this.maxValue}
            included={false}
            step={this.stepValue}
            onChange={this._updateState}
            onAfterChange={this._afterSelection}
            value={this.state.sliderValue}
          />
        </div>
        <span className="slider-bar__weight-percent slider-bar__weight-percent--right" style={rightStyle}>
          <span className="slider-bar__weight-percent-number slider-bar__weight-percent-number--right">
            {rightWeight}
          </span>
          %
        </span>
      </div>
    );
  }
}

export default SliderBar;
